export const DIRECTION_UP = "DIRECTION_UP" ;
export const DIRECTION_DOWN ="DIRECTION_DOWN";